import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// ---------------------------------------------
// Load all JSON files from English folder
// ---------------------------------------------
const enContext = require.context(
  "./locales/en",
  false,
  /\.json$/
);

const deCHContext = require.context(
  "./locales/de-CH",
  false,
  /\.json$/
);

// ---------------------------------------------
// Convert folder JSON files into namespaces
// ---------------------------------------------
const loadTranslations = (context) => {
  const translations = {};

  context.keys().forEach((filePath) => {
    // "./header.json" -> "header"
    const namespace = filePath
      .replace("./", "")
      .replace(".json", "");

    translations[namespace] = context(filePath);
  });

  return translations;
};

// ---------------------------------------------
// Resources
// ---------------------------------------------
const resources = {
  en: loadTranslations(enContext),

  "de-CH": loadTranslations(deCHContext),
};

// ---------------------------------------------
// Saved language
// ---------------------------------------------
const savedLanguage =
  localStorage.getItem("crypsyn-language") || "de-CH";

// ---------------------------------------------
// i18next configuration
// ---------------------------------------------
i18n
  .use(initReactI18next)
  .init({
    resources,

    lng: savedLanguage,

    fallbackLng: "en",

    defaultNS: "common",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;